/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MagiExtractCallbackResult } from '../models/MagiExtractCallbackResult';
import type { MagiRecordInsightData } from '../models/MagiRecordInsightData';
import type { MagiRefineCallbackRequest } from '../models/MagiRefineCallbackRequest';
import type { RelationBlock } from '../models/RelationBlock';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ForMagiCallbackService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * V2 Insight Callback
   * @param id
   * @param slug
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public v2InsightCallbackV1WorkspacesSlugRecordsIdInsightV2CallbackPost(
    id: number,
    slug: string,
    requestBody: MagiExtractCallbackResult
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/records/{id}/insight/v2/callback',
      path: {
        id: id,
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Record not found`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * Insight Callback
   * @param id
   * @param slug
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public insightCallbackV1WorkspacesSlugRecordsIdInsightsCallbackPost(
    id: number,
    slug: string,
    requestBody: MagiRecordInsightData
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/records/{id}/insights/callback',
      path: {
        id: id,
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Record not found`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * Related Record Callback
   * @param id
   * @param slug
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public relatedRecordCallbackV1WorkspacesSlugRecordsIdRelatedRecordsCallbackPost(
    id: number,
    slug: string,
    requestBody: RelationBlock
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/records/{id}/related-records/callback',
      path: {
        id: id,
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Record not found`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * Multi Lang Refine Callback
   * @param id
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public multiLangRefineCallbackV1WorkspacesSlugRecordsIdRefineMultiLangCallbackPost(
    id: number,
    requestBody: MagiRefineCallbackRequest
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/records/{id}/refine/multi-lang/callback',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Transcribe Refine Callback
   * @param id
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public transcribeRefineCallbackV1WorkspacesSlugRecordsIdRefineTranscribeCallbackPost(
    id: number,
    requestBody: MagiRefineCallbackRequest
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/records/{id}/refine/transcribe/callback',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
